import { getStaticImageUrl } from '@utils/createImageUrl';

const LawyerProfileImage = ({ isMobile }: { isMobile?: boolean }) => {
  return (
    <>
      <img
        src={getStaticImageUrl({ fileName: 'preview/top-lawyer.png' })}
        className="for-lawyer-image for-lawyer-top-image view-on-visible"
      />
      <img
        src={getStaticImageUrl({ fileName: 'preview/middle-lawyer.png' })}
        className="for-lawyer-image for-lawyer-middle-image view-on-visible"
      />
      <img
        src={getStaticImageUrl({ fileName: 'preview/bottom-lawyer.png' })}
        className="for-lawyer-image for-lawyer-bottom-image view-on-visible"
      />
      <p className="for-lawyer-day-desc view-on-visible">
        전문성을 강조하려면&nbsp;
        {isMobile && <br />}
        아무래도&nbsp;<span className="for-lawyer-day-desc-bold">변호사 전문 스튜디오</span>에서&nbsp;
        {isMobile && <br />}
        찍는 게&nbsp;
        {!isMobile && <br />}
        좋을 것 같다. 몇 개의 포트폴리오&nbsp;
        {isMobile && <br />}
        확인 후&nbsp;{!isMobile && <br />}
        바로 프로필 촬영을 예약했다.
      </p>
    </>
  );
};

export default LawyerProfileImage;
